/*=========================================================================================
  File Name: i18n.js
  Description: i18n configuration file. Imports i18n data.

==========================================================================================*/

import Vue from "vue";
import VueI18n from "vue-i18n";
import ElementLocale from "element-ui/lib/locale";
import elementUILocaleEn from "element-ui/lib/locale/lang/en";
import elementUILocaleVi from "element-ui/lib/locale/lang/vi";

Vue.use(VueI18n);

function loadLocaleMessages() {
	const locales = require.context("./locales", false, /[A-Za-z0-9-_,\s]+\.json$/i);
	const messages = { en: {}, vi: {} };
	locales.keys().forEach(key => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i);
		if (matched && matched.length > 1) {
			const locale = matched[1];
			if(locale !== "Common") {
				messages.en = { ...messages.en, ...elementUILocaleEn, [locale]: locales(key).en };
				messages.vi = { ...messages.vi, ...elementUILocaleVi, [locale]: locales(key).vi };
			} else {
				messages.en = { ...messages.en, ...elementUILocaleEn, ...locales(key).en };
				messages.vi = { ...messages.vi, ...elementUILocaleVi, ...locales(key).vi };
			}
		}
    });
	return messages;
}

const i18n = new VueI18n({
	silentFallbackWarn: true,
	messages: loadLocaleMessages(),
	locale: process.env.VUE_APP_I18N_LOCALE || "en",
	silentTranslationWarn: process.env.NODE_ENV === "production",
	fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en"
});

export default i18n;

ElementLocale.i18n((key, value) => i18n.t(key, value));
